import { Button, FormControl, HStack, Td, Tr } from "@chakra-ui/react";
import { ProjectType } from "../../utils/types/cycle";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MeasurementDTO } from "../../utils/types/measurment";
import { Select } from "@chakra-ui/react";
import { Option } from "../../utils/types/props.dropdown";

interface DataEntryRowProps {
  project: ProjectType;
  index: number;
  onEnterDataClicked: (id: number, dataType: string) => void;
}

export default function DataEntryRow(props: DataEntryRowProps) {
  const [measurements, setMeasurments] = useState<Option[]>([]);
  const [cycles, setCycles] = useState<Option[]>([]);

  useEffect(() => {
    console.log("props.project.measurements", props);
    setMeasurments(
      props?.project.measurements
        ? props.project.measurements.map((measurement: any) => ({
            label: measurement.name,
            value: String(measurement.id),
          }))
        : []
    );

    setCycles(
      props?.project.cycles
        ? props.project.cycles.map((cycle: any) => ({
            label: `Cycle ${cycle.cycle_number}`,
            value: String(cycle.id),
          }))
        : []
    );
  }, []);
  const [selectedMeasurement, setSelectedMeasurement] =
    useState<MeasurementDTO>({
      name: "",
      measurement_type: "",
      data_type: "",
      target: 0,
      base_line: 0,
      frequency: "",
      department_id: 1,
      technical_area_id: 2,
      id: 0, // Removed the optional operator '?' as it's not valid in object literals
    });
  const [selectedCycle, setSelectedCycle] = useState("");
  const [, setShowMeasurmentError] = useState(false);
  const [, setShowCycleError] = useState(false);
  const [, setMeasurmentDataType] = useState("");

  const [enterDataLoading, setEnterDataLoading] = useState(false);
  const [viewDataLoading, setViewDataLoading] = useState(false);
  const navigate = useNavigate();

  const onEnterClicked = () => {
    const {} = selectedMeasurement;
    // Call the parent component's function with the extracted values
    props.onEnterDataClicked(
      selectedMeasurement.id as number,
      selectedMeasurement.data_type
    );
  };

  const handleMeasurementSelection = (e: any) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    console.log("selectedOption: ", selectedOption.text);

    setSelectedMeasurement(
      props.project.measurements?.filter(
        (measurement: MeasurementDTO) =>
          measurement.name === selectedOption.text
      )[0] as MeasurementDTO
    );
  };

  const handleCycleSelection = (e: any) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    setSelectedCycle(selectedOption.text);
  };

  return (
    <Tr minH={"fit-content"} style={{ zIndex: 999 }}>
      <Td style={{ fontWeight: "normal" }}>{props.index}</Td>
      <Td style={{ fontWeight: "normal" }} colSpan={2}>
        {props.project.name}
      </Td>
      <Td zIndex={1000}>
        <FormControl
          style={{
            width: "100%",

            fontWeight: "normal",
            zIndex: 999,
          }}
        >
          <Select
            placeholder="Select measurement"
            onChange={handleMeasurementSelection}
          >
            {measurements?.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
          {/* <Select
            placeholder="Select Measurement"
            styles={{
              control: (base) => ({
                ...base,
                borderColor: showMeasurmentError ? "red" : "",
                zIndex: 999,
              }),
            }}
            options={
              props?.project.measurements
                ? props.project.measurements.map((measurement: any) => ({
                    label: measurement.name,
                    value: String(measurement.id),
                  }))
                : []
            }
            onChange={(value) => {
              console.log(
                props.project.measurements?.filter(
                  (measurement: MeasurementDTO) =>
                    measurement.name === value?.label
                )[0]
              );

              console.log(
                props.project.measurements?.filter(
                  (measurement: MeasurementDTO) =>
                    measurement.name === value?.label
                )[0]
              );

              setSelectedMeasurement(
                props.project.measurements?.filter(
                  (measurement: MeasurementDTO) =>
                    measurement.name === value?.label
                )[0] as MeasurementDTO
              );
            }}
          /> */}
        </FormControl>
      </Td>
      <Td>
        <FormControl
          style={{
            width: "100%",
            fontWeight: "normal",
          }}
        >
          <Select placeholder="Select cycle" onChange={handleCycleSelection}>
            {cycles?.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </FormControl>
      </Td>
      <Td>
        <HStack>
          <Button
            colorScheme="blue"
            size="md"
            fontWeight={"normal"}
            fontSize={14}
            isLoading={enterDataLoading}
            onClick={() => {
              console.log("selected measurment: ", selectedMeasurement);

              if (selectedMeasurement.name === "" || selectedCycle === "") {
                setShowMeasurmentError(true);
                setShowCycleError(true);
              } else if (selectedCycle === "") {
                setShowCycleError(true);
              } else if (selectedMeasurement.name === "") {
                setShowMeasurmentError(true);
              } else {
                setShowMeasurmentError(false);
                setMeasurmentDataType(selectedMeasurement.data_type);
                setShowCycleError(false);
                setEnterDataLoading(true);
                setTimeout(() => {
                  onEnterClicked();
                  setEnterDataLoading(false);
                }, 1000);
              }
            }}
          >
            Enter Data
          </Button>
          <Button
            colorScheme="green"
            size="md"
            fontWeight={"normal"}
            fontSize={14}
            isLoading={viewDataLoading}
            onClick={() => {
              console.log(selectedMeasurement, selectedCycle);

              if (selectedMeasurement.name === "" || selectedCycle === "") {
                console.log("am here 1");

                setShowMeasurmentError(true);
                setShowCycleError(true);
              } else if (selectedCycle === "") {
                setShowCycleError(true);
              } else if (selectedMeasurement.name === "") {
                setShowMeasurmentError(true);
              } else {
                setViewDataLoading(true);
                setTimeout(() => {
                  setViewDataLoading(false);

                  navigate(`data/${props.project.name}`, {
                    state: {
                      measurement: selectedMeasurement,
                      project: props.project.name,
                      type: selectedMeasurement,
                    },
                  });
                }, 2000);
              }
            }}
          >
            View Data
          </Button>
        </HStack>
      </Td>
    </Tr>
  );
}
